import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,{staticClass:"input input-search disabled",attrs:{"value":_vm.input,"label":_vm.label,"outlined":"","hide-details":!_vm.hint,"type":_vm.type,"disabled":_vm.disabled,"prepend-icon":_vm.icon,"hint":_vm.hint,"rules":[
    v => {
      if (v.indexOf('.') >= 0) return false;
      if (!v.trim()) return true;
      if (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999) return true;
      return false;
    },
  ]},on:{"input":_vm.inputChanged,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.addValue.apply(null, arguments)},"blur":_vm.addValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }